import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  CCreateElement,
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CSidebarNavDivider,
  CSidebarNavTitle,
  // CSidebarNavDropdown,
  CSidebarNavItem,
  CSidebarMinimizer,
} from '@coreui/react';
import navigation from './_nav';
import logo from '../assets/images/logo4.png';
// import logo_mini from '../assets/images/logo_mini.png';
import Highcharts from 'highcharts';
import { getCurrentUser } from '@aws-amplify/auth';
// import SiteReload from 'src/views/sites/SiteReload';

// サイト概要 アイテム
// const createDropdownItems = (sites) => {
//   return sites ? sites.map( site => (
//     {
//       _tag: 'CSidebarNavItem',
//       name: site.name,
//       to: '/sites/'+ site.id ,
//     }
//   )) : [];
// }

const TheSidebar = () => {
  const dispatch = useDispatch();
  const show = useSelector((state) => state.sidebarShow);
  // const sitesData = useSelector(state => state.sitesData);
  const navigationList = useSelector((state) => state.navigationList);
  const [currentUser, setCurrentUser] = useState(null);
    useEffect(() => {
    const fetchUser = async () => {
      try {
        const user = await getCurrentUser();
        setCurrentUser(user);
      } catch (error) {
        setCurrentUser(null);
      }
    };
    fetchUser();
  }, []);

  const setNavigation = () => {
    let navigationForDisplay = [];

    for (const item of navigation) {
      if (item.megasolar_include_flag) {
        navigationForDisplay.push(item);
      }
    }

    dispatch({ type: 'set', navigationList: navigationForDisplay });
  };

  // サイト概要ツリー置換
  // navigation[1]._children = createDropdownItems(sitesData);
  // if (siteList.length === 0) {
  //   dispatch({ type: 'set', siteNameFlag: 1 });
  // }
  // navigation[1]._children = createDropdownItems(siteList);

  useEffect(() => {
    // サイトバーの表示／非表示を変えるとき、Highchartsの幅を
    // コンテナにあわせて表示するようにエベントを追加
    window.addEventListener('transitionend', () => {
      Highcharts.charts.forEach((chart, idx, array) => {
        if (typeof chart !== 'undefined') {
          chart.reflow();
        }
      });
    });
  });

  useEffect(() => {
    //画面表示時にサイドバー表示項目設定
    setNavigation();
  }, [currentUser]);

  return (
    <CSidebar show={show} onShowChange={(val) => dispatch({ type: 'set', sidebarShow: val })}>
      <CSidebarBrand className="d-md-down-none sed-om-sidebar-brand">
        <div className="sed-om-sidebar-logo-wrapper c-sidebar-brand-full">
          <div className="logo">
            <img src={logo} alt="自然電力" style={{ width: '40%' }} />
          </div>
          <p className="site">機器制御型DR（EQ）</p>
          <p className="site">管理システム</p>

          {currentUser?.signInDetails?.['loginId'] && <p className="name">{currentUser?.signInDetails?.['loginId']}</p>}
        </div>
        <div className="sed-om-sidebar-logo-wrapper c-sidebar-brand-minimized">
          <div className="logo">
            <img src={logo} alt="自然電力" style={{ width: 40 }} />
          </div>
        </div>
      </CSidebarBrand>
      <CSidebarNav>
        <CCreateElement
          items={navigationList}
          components={{
            CSidebarNavDivider,
            //CSidebarNavDropdown,
            CSidebarNavItem,
            CSidebarNavTitle,
          }}
        />
      </CSidebarNav>

      <CSidebarMinimizer className="c-d-md-down-none" />
    </CSidebar>
  );
};

export default React.memo(TheSidebar);
